(function () {
  'use strict';

  angular
    .module('app.lazyload')
    .config(lazyloadConfig);

  lazyloadConfig.$inject = ['$ocLazyLoadProvider', 'APP_REQUIRES'];

  function lazyloadConfig($ocLazyLoadProvider, APP_REQUIRES) {
    // Lazy Load modules configuration
    $ocLazyLoadProvider.config({
      debug: false,
      events: true,
      modules: APP_REQUIRES.modules
    });
  }
})();
